export default __webpack_public_path__ + "images/nVent-RAYCHEM-Logo-RGB-Horizontal.png?42c8e2feda340b3d0e510d100e2f50fa";